import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IProcess, IOperation } from 'src/app/user-identification/models/user-identification';

@Injectable({
	providedIn: 'root',
})
export class OperationService {
	private $operations: BehaviorSubject<IOperation[]>;

	constructor() {
		this.$operations = new BehaviorSubject<IOperation[]>(null);
	}

	public getOperations(): Observable<IOperation[]> {
		return this.$operations.asObservable();
	}

	public setOperations(value: IOperation[]): void {
		this.$operations.next(value);
	}

	public updateOperation(operationIndex: number, updatedOperation: IOperation): void {
		const currentOperations = this.$operations.value;
		if (currentOperations && operationIndex >= 0 && operationIndex < currentOperations.length) {
			const updatedOperations = [...currentOperations];
			updatedOperations[operationIndex] = updatedOperation;
			this.$operations.next(updatedOperations);
		}
	}

	public getCurrentOperations(): IOperation[] | null {
		return this.$operations.value;
	}

	public convertProcessBackToFront(process: IProcess): Array<IOperation> {
		return process.operations;
	}
}
